"use client";

import {
  createContext,
  useContext,
  useMemo,
  useState,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
} from "react";
import type { CodeLang } from "@/lib/code-lang";

interface CodeLangContextValue {
  activeLang: CodeLang | null;
  setActiveLang: Dispatch<SetStateAction<CodeLang | null>>;
}

const CodeLangContext = createContext<CodeLangContextValue>({
  activeLang: null,
  setActiveLang: () => undefined,
});

export function CodeLangProvider({ children }: PropsWithChildren) {
  const [activeLang, setActiveLang] = useState<CodeLang | null>(null);
  const value = useMemo(
    () => ({ activeLang, setActiveLang }),
    [activeLang],
  );

  return (
    <CodeLangContext.Provider value={value}>
      {children}
    </CodeLangContext.Provider>
  );
}

export function useCodeLang(): CodeLangContextValue {
  return useContext(CodeLangContext);
}
